import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Icon from '../IconWithBranding'

const Container = styled.div`
  margin: 15% auto;
  text-align: center;
`

/* Similar with NotFound404Route BUT WIHTOUT the Layout */

const NotFound404View = () => {
  const { t } = useTranslation()

  return (
    <Container>
      <h1>
        <Icon icon={['far', 'frown']} />
      </h1>
      <h2>{t('errors.404')}</h2>
    </Container>
  )
}

export default NotFound404View
